import DownloadAPKButton from "./DownloadAPKButton";
import PhoneMockup from "./PhoneMockup";

const heroTags = [
  "Chiffrement zero-knowledge",
  "Résistant à l'extraction forensic",
  "Verrouillage à distance",
];

export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-inner">
        <div className="hero-content">
          <p className="hero-badge">PROTECTION DE LA VIE PRIVÉE ANDROID</p>
          <h1 className="hero-title">
            Vos photos et vos fichiers n&apos;appartiennent{" "}
            <span className="neon-text">qu&apos;à vous.</span>
          </h1>
          <p className="hero-desc">
            SAFE chiffre vos données de bout en bout, en zero-knowledge&nbsp;:
            personne — pas même nous — ne peut y accéder. Et si votre téléphone
            est volé, perdu ou saisi, vous gardez le contrôle à distance.
          </p>
          <div className="hero-cta">
            <DownloadAPKButton
              text="Télécharger l'APK (bêta)"
              className="btn btn-primary btn-lg"
              showIcon
            />
            <a href="#tutorial" className="hero-tutorial-link">
              Voir le tutoriel d&apos;activation ↓
            </a>
          </div>
          <div className="hero-tags">
            {heroTags.map((tag) => (
              <span key={tag} className="hero-tag">
                {tag}
              </span>
            ))}
          </div>
        </div>
        <div className="hero-visual">
          <PhoneMockup
            src="/images/bannerScreens/1.jpg"
            alt="SAFE — Tableau de bord de l'application"
            className="hero-phone-mockup"
          />
        </div>
      </div>
    </section>
  );
}
